import { Component, Input, OnInit } from '@angular/core';
import { IBreadcrumb } from './breadcrumbs.interface';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
  @Input() path: string = '';
  @Input() mt_0: boolean = false;

  breadcrumbs: IBreadcrumb[] = [];

  ngOnInit(): void {
    this.breadcrumbs = this.path.split('/').filter((item: string) => item !== '').map((item: string) => {
      return {
        url: this.path.split(item)[0] + item,
        title: item[0].toUpperCase() + item.slice(1).replace(/-/g, ' '),
      }
    });
  }
}